
import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, ChefHat, Truck, Home, Settings, LogOut, History, DollarSign } from 'lucide-react';
import { useApp } from '@/contexts/AppContext';
import { Button } from '@/components/ui/button';

const MobileNav: React.FC = () => {
  const { currentUser, logout } = useApp();
  
  // Verificação explícita para isManager true
  const isAdmin = currentUser?.role === 'admin';
  const isManager = currentUser?.isManager === true;
  const isAdminOrManager = isAdmin || isManager;
  
  // Obter o tipo de empresa do localStorage
  const empresaTipo = localStorage.getItem('empresa_tipo') || 'Restaurante';
  const isRestaurante = empresaTipo === 'Restaurante';
  
  console.log('MobileNav rendering with currentUser:', {
    currentUser,
    isAdmin,
    isManager,
    isAdminOrManager,
    role: currentUser?.role,
    isManagerValue: currentUser?.isManager,
    empresaTipo,
    isRestaurante
  });
  
  // Determinar quais itens do menu mostrar com base no papel do usuário e tipo de empresa
  const showHome = true; // Todos os usuários veem a página inicial
  // IMPORTANTE: usuários com isManager=true também veem todas as opções, mas apenas as relevantes para o tipo de empresa
  const showTables = isRestaurante && (isAdminOrManager || ['waiter'].includes(currentUser?.role || ''));
  const showKitchen = isRestaurante && (isAdminOrManager || ['kitchen'].includes(currentUser?.role || ''));
  const showDelivery = isAdminOrManager || ['delivery'].includes(currentUser?.role || '');
  // IMPORTANTE: Mostrar Settings para admin ou manager (gestor)
  const showSettings = isAdminOrManager;
  // Mostrar botões de caixa e histórico apenas para admin e garçom
  const showCashierOptions = isAdminOrManager || ['waiter'].includes(currentUser?.role || '');
  
  console.log('MobileNav rendering with:', { 
    showTables, 
    showKitchen, 
    showDelivery,
    showSettings,
    showCashierOptions
  });
  
  return (
    <nav className="fixed bottom-0 left-0 z-50 flex w-full justify-around border-t py-2 bg-background shadow-md">
      <NavLink 
        to="/" 
        className={({ isActive }) => 
          `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
            isActive ? 'text-primary' : 'text-muted-foreground'
          }`
        }
      >
        <Home size={24} />
        <span>Início</span>
      </NavLink>
      
      {showTables && (
        <NavLink 
          to="/tables" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <LayoutGrid size={24} />
          <span>Mesas</span>
        </NavLink>
      )}
      
      {showKitchen && (
        <NavLink 
          to="/kitchen" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <ChefHat size={24} />
          <span>Cozinha</span>
        </NavLink>
      )}
      
      {showDelivery && (
        <NavLink 
          to="/delivery" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <Truck size={24} />
          <span>Entregas</span>
        </NavLink>
      )}
      
      {showCashierOptions && (
        <NavLink 
          to="/cashier-closing" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <DollarSign size={24} />
          <span>Caixa</span>
        </NavLink>
      )}
      
      {showCashierOptions && (
        <NavLink 
          to="/completed-tables" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <History size={24} />
          <span>Histórico</span>
        </NavLink>
      )}
      
      {showSettings && (
        <NavLink 
          to="/settings" 
          className={({ isActive }) => 
            `flex flex-col items-center space-y-1 text-xs font-medium transition-colors ${
              isActive ? 'text-primary' : 'text-muted-foreground'
            }`
          }
        >
          <Settings size={24} />
          <span>Config</span>
        </NavLink>
      )}

      {/* Adicionando o botão de sair na navegação mobile */}
      <Button 
        variant="ghost" 
        size="sm" 
        className="flex flex-col items-center space-y-1 text-xs font-medium transition-colors text-muted-foreground hover:text-primary"
        onClick={logout}
      >
        <LogOut size={24} />
        <span>Sair</span>
      </Button>
    </nav>
  );
};

export default MobileNav;
